import { render, staticRenderFns } from "./Feather.vue?vue&type=template&id=27d49176&"
import script from "./Feather.vue?vue&type=script&lang=js&"
export * from "./Feather.vue?vue&type=script&lang=js&"
import style0 from "./Feather.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports